var map = {
	"./direct.png": 2491,
	"./excel.png": 7087,
	"./facebook.png": 5260,
	"./fixdigital.png": 3207,
	"./google-ads.png": 4680,
	"./hand.png": 207,
	"./instagram.png": 6750,
	"./linkedin.png": 2098,
	"./logo-w.png": 925,
	"./logo-w@2x.png": 8663,
	"./logo.png": 3153,
	"./logo@2x.png": 7459,
	"./newsletter.png": 6977,
	"./outbrain.png": 3584,
	"./phone.png": 2978,
	"./print.png": 4951,
	"./radio.png": 9443,
	"./tiktok.png": 4934,
	"./tv.png": 6610,
	"./whatsapp.png": 650,
	"./youtube.png": 4149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;